import React from 'react';
import { Link } from 'react-router-dom';
import { EstimationLogo } from '../../assets/EstimationLogo';

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t bg-card">
      <div className="container max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 mb-8">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <EstimationLogo className="h-6 w-6" variant="dark" />
              <span className="text-lg font-bold tracking-wider text-foreground transform skew-x-[-1deg]">
                ESTIMATION<span className="text-accent">.PK</span>
              </span>
            </div>
            <p className="text-sm text-muted-foreground mb-4 max-w-xs">
              Modern packaging cost estimation platform built for manufacturers and converters in Pakistan.
            </p>
            <p className="text-xs text-muted-foreground">
              © {currentYear} Estimation.pk. All rights reserved.
            </p>
          </div>

          {/* Product Column */}
          <div>
            <h3 className="font-semibold text-sm mb-4 text-foreground">Product</h3>
            <ul className="space-y-2.5">
              <li>
                <a href="/#features" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Features
                </a>
              </li>
              <li>
                <a href="/#pricing" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Pricing
                </a>
              </li>
              <li>
                <a href="/#faq" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  FAQ
                </a>
              </li>
              <li>
                <a 
                  href="https://status.estimation.pk" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                >
                  Status
                </a>
              </li>
            </ul>
          </div>

          {/* Company Column */}
          <div>
            <h3 className="font-semibold text-sm mb-4 text-foreground">Company</h3>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal Column */}
          <div>
            <h3 className="font-semibold text-sm mb-4 text-foreground">Legal</h3>
            <ul className="space-y-2.5">
              <li>
                <Link to="/terms" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/cookies" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Cookie Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-border">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-xs text-muted-foreground text-center md:text-left">
              Built with ❤️ for the packaging industry
            </p>
            <div className="flex items-center gap-6">
              <a 
                href="mailto:support@estimation.pk" 
                className="text-xs text-muted-foreground hover:text-foreground transition-colors"
              >
                support@estimation.pk
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
